import React from "react";
import { Loader2, FileText } from "lucide-react";

const DIMENSIONS = [
  ["problem_clarity", "Problemverständnis"],
  ["user_roles", "Nutzer & Rollen"],
  ["process_logic", "Prozesslogik"],
  ["data_model", "Datenmodell"],
  ["integration_context", "Integrationen"],
  ["security_context", "Security"],
  ["deployment_context", "Betrieb & Hosting"],
];

const OVERALL = {
  prototype_ready: "Bereit für einen Prototyp",
  needs_clarification: "Fachliche Klärung nötig",
  workshop_required: "Workshop empfohlen",
  do_not_build_yet: "Jetzt noch nicht bauen",
  not_ready: "Noch nicht entscheidungsreif",
};

function Dot({ value }) {
  const cls =
    value === "green"
      ? "bg-emerald-600"
      : value === "yellow"
      ? "bg-amber-500"
      : value === "red"
      ? "bg-red-600"
      : "bg-aw-fog";
  return <span className={`inline-block w-2.5 h-2.5 rounded-full ${cls}`} />;
}

export default function ReadinessView({ state, busy, onGenerate }) {
  const r = state?.readiness;
  return (
    <div className="bg-card border border-border" data-testid="dlab-readiness">
      <div className="border-b border-border px-6 py-3">
        <div className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">Readiness — reicht die Klarheit für einen Prototyp?</div>
      </div>

      <div className="px-6 py-6">
        {!r ? (
          <div className="text-sm text-muted-foreground">Readiness wird berechnet …</div>
        ) : (
          <>
            <h2 className="font-display text-2xl md:text-3xl text-foreground" data-testid="dlab-readiness-overall">
              {OVERALL[r.overall_status] || r.overall_status}
            </h2>
            {r.recommendation ? (
              <p className="text-sm text-muted-foreground mt-2 max-w-2xl">{r.recommendation}</p>
            ) : null}

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-border border border-border mt-6">
              {DIMENSIONS.map(([key, label]) => (
                <div key={key} className="bg-card px-4 py-3 flex items-center justify-between gap-3">
                  <span className="text-sm text-foreground leading-snug">{label}</span>
                  <span className="shrink-0"><Dot value={r[key]} /></span>
                </div>
              ))}
            </div>
          </>
        )}

        <div className="mt-8 flex items-center gap-4">
          <button
            type="button"
            onClick={onGenerate}
            disabled={busy === "artifacts"}
            className="inline-flex items-center gap-2 bg-aw-coral text-white font-medium text-sm px-5 py-2.5 rounded-full disabled:opacity-60 hover:brightness-95 transition"
            data-testid="dlab-generate-artifacts"
          >
            {busy === "artifacts" ? <Loader2 className="w-4 h-4 animate-spin" /> : <FileText className="w-4 h-4" />}
            {busy === "artifacts" ? "Die KI strukturiert die Discovery …" : "Projektkontext erzeugen"}
          </button>
          {busy === "artifacts" ? (
            <span className="text-xs text-muted-foreground">Strukturierung und Zusammenfassung laufen — das dauert bis zu zwei Minuten.</span>
          ) : null}
        </div>
      </div>
    </div>
  );
}
